export const OPEX_MODELLING_APPROACH = {
  ABSOLUTE_VALUE: `absolute_value`,
  PERCENTAGE_OF_REVENUE: `percentage_of_revenue`,
} as const

export const OPEX_GRANULARITY_LEVELS = {
  AGGREGATE_EXPENSES: `aggregate_expenses`,
  DETAILED_EXPENSES: `detailed_expenses`,
} as const
